


































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Form from "@/components/Form/Form.vue";
import {Action, Getter, Mutation} from "vuex-class";
import Input from "@/components/Form/elements/Input.vue";
import ITimeTrackingRecord from "@/models/TimeTracking/ITimeTrackingRecord";
import Select from "@/components/Form/elements/Select.vue";
import AuthService from "@/service/AuthService";
import AppConfig from "@/config/AppConfig";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Modal from "@/components/Modal/Modal.vue";
import ModalCard from "@/components/Modal/ModalCard.vue";
import SimpleTable from "@/components/SimpleTable/SimpleTable.vue";
import App from "@/App.vue";
import ITimeTrackingTask from "@/models/TimeTracking/ITimeTrackingTask";
import ConvertService from "@/service/ConvertService";


const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';
const NAMESPACE_TIME_TRACKING_TASK: string = 'timeTrackingTasks';

const RESOURCE_TIME_TRACKING_RECORD: string = 'tt/record';
const RESOURCE_TIME_TRACKING_TASK: string = 'tt/task';

@Component({
  components: {SimpleTable, ModalCard, Modal, Select, Input, Form, VueCtkDateTimePicker}
})
export default class ContinueRecord extends Vue {
  public name: string = "ContinueRecord";

  // @Action('loadDropdownData', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) loadDropdownData: any;
  @Action('createItem', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) createItem: any;
  @Action('loadLastRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) loadLastRecord: any;
  @Action('loadDropdownData', {namespace: NAMESPACE_TIME_TRACKING_TASK}) loadDropdownData: any;
//  @Action('fetchFieldSuggestions', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) fetchFieldSuggestions: any;

  @Getter('getDataList', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) timeTrackingRecords: any;
  @Getter('getLastRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) lastRecord;
  @Getter('getDropdownData', {namespace: NAMESPACE_TIME_TRACKING_TASK}) dropdownData: any;
  @Getter('getValidationErrors', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) validationErrors: any;
  @Getter('getRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) runningTimeTrackingRecord: any;

  @Prop({required: true})
  public visible!: boolean;

  @Prop({required: true})
  public presets!: ITimeTrackingRecord;


  private start?: string = '';
  private stop?: string = '';
  private text?: string = '';
  private ticketUrl?: string = '';
  private typeId?: number = 1;
  private type: any;
  private clientId?: number = 1;
  private brandId?: number = 2;
  private projectId?: number = 1;
  private taskId?: number = -1;
  private userId?: number = -1;
  private createdAt?: string = '';
  private updatedAt?: string = '';
  private newProject?: string = '';
  private newBrand?: string = '';


  private authService: any = new AuthService();

  private currentUserId: number = this.authService.getUserId();


  @Watch('visible', {immediate: true})
  onVisibleChanged(newVal: boolean, oldVal: boolean) {

    if (!oldVal && newVal) {

      this.init(this.presets);

    }

  }

  private init(task: ITimeTrackingTask): void {

    this.loadLastRecord({resource: RESOURCE_TIME_TRACKING_RECORD});
    this.loadDropdownData({resource: RESOURCE_TIME_TRACKING_TASK});

    if (task) {

      this.$nextTick(() => {

        let record: any = task.records && task.records.length > 0 ? task.records[task.records.length - 1] : null;

        this.start = this.$moment().format(AppConfig.DATETIME_FORMAT_SQL);
        this.stop = undefined;
        this.text = record ? record.text : '';
        this.ticketUrl = record ? record.ticket_url : '';
        this.taskId = task.id;
        this.clientId = task.client_id;
        this.brandId = task.brand_id;
        this.projectId = 0;
        this.newProject = task.title?.substr(0, 23);
        this.userId = task.owner_id;
        this.createdAt = task.created_at;
        this.updatedAt = task.updated_at;

      });

    }

  }

  private get typeDropdownOptions(): any {

    if (this.dropdownData && this.dropdownData.hasOwnProperty('types')) {

      return ConvertService.dbResultsToSelectOptions(this.dropdownData.types, 'name', 'id', 'name');

    }

    return null;

  }


  private get newItem(): ITimeTrackingRecord {

    return {
      text: this.text,
      ticket_url: this.ticketUrl,
      start: this.start,
      stop: this.stop,
      task_id: this.taskId,
      client_id: this.clientId,
      brand_id: this.brandId,
      type_id: this.typeId,
      project_id: this.projectId,
      new_project: this.newProject,
      type: this.type,
      user_id: this.userId,
      created_at: this.createdAt,
      updated_at: this.updatedAt
    };

  }

  private get appConfig(): AppConfig {

    return AppConfig;

  }

  private onStartNewRecord(): void {

    this.createItem({resource: RESOURCE_TIME_TRACKING_RECORD, data: this.newItem})
        .then((response) => {
          this.$emit('active-changed', false);
        })


  }

  private setStartTimeTo(mode = 'now', dateTime: string = ''): void {

    switch (mode) {
      case 'now':
        this.start = this.$moment().format(AppConfig.DATETIME_FORMAT_SQL);
        return;
      case 'last_stop':

        let lastStop: string = '';

        if (this.lastRecord) {

          lastStop = this.lastRecord.stop;

        }

        this.start = lastStop === '' ? this.$moment().format(AppConfig.DATETIME_FORMAT_SQL) : lastStop;
        return;

    }

    this.start = this.$moment(dateTime).format(AppConfig.DATETIME_FORMAT_SQL);

  }


}
